import { useConfig, IConfig } from 'src/providers/ConfigProvider';

// STOP! You probably don't want to use this hook directly.
// In most cases, the value you want ought to be provided instead by FeatureProvider or StringProvider.
// Use this sparingly, or for one-offs, like for PDP type.
export function useConfigOption<K extends keyof IConfig>(key: K, defaultValue: IConfig[K]): IConfig[K] {
  const config = useConfig();

  if (key in config && !!config[key]) {
    return config[key] as IConfig[K];
  }

  return defaultValue;
}
